// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2GA-Z","filesListContainer":"PosDisputesFiles_filesListContainer__3yYU-","filesButton":"PosDisputesFiles_filesButton__2a7i5"};